/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { SagaIterator } from 'redux-saga';
import { call, select } from 'redux-saga/effects';
import { Asset, Ducks, MenuItem, MenuItemType } from '@wit/vtv-x-foundation-lib';
import { SeasonsData } from '../seasons';

import WITHOUT_RECOM from './bestEpisodeWithoutRecom';
import WITH_RECOM from './bestEpisodeWithRecom';
import * as Gdpr from '../../gdpr';

function* getBestEpisode(
  seasonsData: SeasonsData,
  entryAsset: Asset,
  entryMenuItem?: MenuItem
): SagaIterator<Asset | undefined> {
  let bestEpisode;
  const isRecomendationsActive = yield select(Ducks.Recommendations.Selectors.isFeatureEnabled);
  const isGdprConsent = yield select(Gdpr.Selectors.hasAgreedToConsent);
  if (
    isRecomendationsActive &&
    isGdprConsent &&
    entryMenuItem &&
    (entryMenuItem.type === MenuItemType.EXTERNAL || entryMenuItem.type === MenuItemType.EXTERNAL_SEARCH)
  ) {
    bestEpisode = yield call(WITH_RECOM.getBestEpisode, seasonsData, entryAsset, entryMenuItem);
  } else {
    bestEpisode = yield call(WITHOUT_RECOM.getBestEpisode, seasonsData);
  }

  return bestEpisode;
}

export default {
  getBestEpisode,
};
